var map = {
	"./一体化大数据分析平台.png": 7772,
	"./国企合规性自查自纠管理系统.png": 6908,
	"./安全运营.png": 6609,
	"./数字供应链一站式竞价平台.png": 5035,
	"./智慧园区数智平台.png": 8888,
	"./智能运营.png": 1121,
	"./知识图谱系统.png": 1043
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1942;